import { Add } from "@mui/icons-material";
import { Divider, IconButton, Stack, Typography } from "@mui/material";
import { Medication } from "src/api/types";
import DataTable from "src/components/DataTable";
import WhiteCard from "src/components/WhiteCard";
import { useColumns } from "./useColumns";
import AddStrengthModal from "./AddStrengthModal";
import { useManageModal } from "src/hooks/useManageModal";
import { useEffect } from "react";

interface Props {
  medication: Medication;
}

const MedicationStrength = ({ medication }: Props) => {
  const columns = useColumns();
  const [open, { handleClose, handleOpen }] = useManageModal();

  const openFromPrice = localStorage.getItem("open-medication-strength");

  useEffect(() => {
    if (openFromPrice == null || openFromPrice === "false") return;

    handleOpen();
  }, [handleOpen, openFromPrice]);

  return (
    <>
      <WhiteCard width={"500px"} gap={3}>
        <Stack gap={1}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography fontWeight={600}>Medication Strength</Typography>
            <IconButton onClick={handleOpen}>
              <Add color="secondary" />
            </IconButton>
          </Stack>
          <Divider sx={{ backgroundColor: "#000000" }} />
        </Stack>
        <DataTable
          data={medication.medication_strength}
          columns={columns}
          primaryKey="id"
        />
      </WhiteCard>
      <AddStrengthModal open={open} onClose={handleClose} />
    </>
  );
};

export default MedicationStrength;
